<template>
  <div class="order-detail">
    <div class="crumbs-navigation">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/main' }">{{ $t('homePage.myQuotation') }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('homePage.viewDetails') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="margin-t">
      <el-row>
        <el-col :span="6">
          <span style="margin-right: 10px">
            {{ $t('homePage.quotationOnly') }}
          </span>
          {{ this.projectBaseInfo.projectId }}
        </el-col>
        <el-col :span="6">
          <span style="margin-right: 10px">
            {{ $t('homePage.theNameList') }}
          </span>
          {{ this.projectBaseInfo.projectName }}
        </el-col>
        <el-col
          :span="6"
          v-if="IsChannel"
        >
          <!--ECP系统对应项目名称：{{ this.projectBaseInfo.crmProjectName }}-->
        </el-col>
        <el-col :span="6">
          {{ $t('homePage.remarks') }}
          {{ this.projectBaseInfo.projectRemark }}
        </el-col>
      </el-row>
    </div>
    <div class="margin-t">
      <el-row>
        <el-col :span="24">
          <div class="grid-content ">
            <a>
              {{ $t('exportExcelModule.catalogPrice') }}
              <span class="f-blue">
                {{ productPriceFormat(null,null,this.projectBaseInfo.projectTotalPrice) }}
              </span>
            </a>
          </div>
          <div class="grid-content ">
            <a>
              <!--折后总价：-->
              {{ $t('createQuotation.totalPriceAfterDiscount') }}
              <span class="f-blue">
                {{ productPriceFormat(null,null,this.projectBaseInfo.projectDiscountTotalPrice) }}
              </span>
            </a>
          </div>
          <div class="grid-content ">
            <a>
              <!--整单折扣：-->
              {{ $t('createQuotation.wholeSingleDiscount') }}
              <span class="f-blue">
                {{ this.projectBaseInfo.projectRatio | number }}%
              </span>
            </a>
          </div>
          <div class="grid-content-r">
            <span v-if="fileArchive !==0">
              <el-button class="operate-btn" @click="editProject(projectBaseInfo.projectId)">
                <!--编辑-->
                {{ $t('homePage.compile') }}
              </el-button>
              <el-button class="operate-btn" @click="copyProject(projectBaseInfo.projectId)">
                <!--复制-->
                {{ $t('homePage.copy') }}
              </el-button>
              <el-button class="operate-btn" @click="exportProject(projectBaseInfo.projectId)">
                <!--导出-->
                {{ $t('homePage.export') }}
              </el-button>
              <el-button class="operate-btn" @click="shareProject(projectBaseInfo.projectId)">
                <!--分享-->
                {{ $t('homePage.share') }}
              </el-button>
            </span>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="table-one" style="overflow: auto">
      <table id="table1" style="width: 100%;">
        <thead class="table-thead">
          <tr>
            <th style="width:150px;">
              {{ $t('createQuotation.configurationSet') }}
            </th>
            <th style="width:150px;">
              <!--产品系列-->
              {{ $t('createQuotation.productSeries') }}
            </th>
            <th style="width:35px;">
              <!--套数-->
              {{ $t('addConfigModule.numberOf') }}
            </th>
            <th style="width:150px;">
              <!--产品名称-->
              {{ $t('addConfigModule.productName') }}
            </th>
            <th style="width:400px;">
              <!--产品型号-->
              {{ $t('addConfigModule.productModel') }}
            </th>
            <th>
              <!--产品描述-->
              {{ $t('addConfigModule.productDes') }}
            </th>
            <th style="width:100px;">
              <!--折扣值（%）-->
              {{ $t('createQuotation.theDiscountValue') }}
            </th>
            <th style="width:100px;">
              <!--目录单价（元）-->
              {{ $t('createQuotation.directoryPrice') }}
            </th>
            <th style="width:100px;">
              <!--折后单价（元）-->
              {{ $t('createQuotation.afterFoldingUnitPrice') }}
            </th>
            <th style="width:100px;">
              <!--总数量-->
              {{ $t('createQuotation.totalNumber') }}
            </th>
            <th style="width:100px; text-align: left">
              <!--备注-->
              {{ $t('homePage.remarks') }}
            </th>
            <th style="width:300px; text-align: left">
              <!--替换产品-->
              {{ $t('productAdded.replaceProduct') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,index) in prolists" :key="index">
            <template v-if="item.type==='total'">
              <td colspan="6" style="font-weight: 700;color: #000000; text-align: left; background-color: #eef1f6; padding-left: 10px;">
                {{ $t('createQuotation.subtotal') }}
              </td>
              <!--折扣值-->
              <td style="color:#000000; font-weight: 700;text-align: right;padding-right: 10px">
                {{ item.totalRatio | number }}
              </td>
              <td style="color:#000000; font-weight: 700;text-align: right;padding-right: 10px">
                {{ productPriceFormat(null,null,item.totalPrice) }}
              </td>
              <td style="color:#000000;font-weight: 700;text-align: right;padding-right: 10px">
                {{ productPriceFormat(null,null,item.discountTotalPrice) }}
              </td>
              <td style="color:#000000;font-weight: 700;text-align: left;padding: 0 10px">
                {{ item.groupNum }}
              </td>
              <td />
              <td />
            </template>
            <template v-else-if="item.type==='em'">
              <td
                class="group-name-styles"

                @click="toAdditionPro(item.groupId,item.groupName)"
              >
                {{ item.groupName }}
              </td>
              <td style="color:#36BADE;" colspan="7" />
            </template>
            <template v-else>
              <td
                :rowspan="rowspanNum1(item)"
                v-if="!item.lv3index&&!item.lv2index"
                style="text-align: left;padding: 0 10px;color:#36BADE;cursor: pointer"
                @click="toAdditionPro(item.groupId,item.groupName,item.isServiceFlag)"
              >
                {{ item.groupName }}
              </td>
              <td
                :rowspan="item.row2length"
                v-if="!item.lv3index"
                style="text-align: left;padding: 0 10px;"
              >
                {{ item.productSeriesName }}
              </td>
              <td
                :rowspan="item.row2length"
                v-if="!item.lv3index"
                style="width:35px;"
              >
                {{ item.tcount }}
              </td>
              <td style="text-align: left;padding: 0 10px;">
                {{ item.productAlias }}
              </td>
              <td style="text-align: left;padding: 0 10px;">
                {{ item.productName }}
                <span
                  v-if="!item.industryIsEnabled"
                  class="promotion"
                >
                  <img src="../../assets/shelves-new.png" alt="err">
                </span>
                <span
                  v-if="item.quotation===1"
                  class="promotion2"
                >
                  <img src="../../assets/fuwushang-new.png">
                </span>
                <span
                  v-if="item.quotation===2 && getStore('industryFlg') === 1" class="promotion2"
                >
                  <img src="../../assets/fuwushang-new.png" alt="err">
                </span>
              </td>
              <td style="padding: 0 20px 0 10px;text-align: left">
                <longText :text="item.productDesc" :switch-flg="switchFlgP" />
              </td>
              <td style="text-align: right;padding-right: 10px">
                {{ item.discountRatio | number }}
              </td>
              <td style="text-align: right;padding-right: 10px">
                {{ productPriceFormat(null,null,item.productPrice) }}
              </td>
              <td style="text-align: right;padding-right: 10px">
                {{ productPriceFormat(null,null,item.discountPrice) }}
              </td>
              <td style="text-align: left;padding: 0 10px">
                {{ item.purchaseQuantity*item.tcount }}
              </td>
              <td style="text-align: left;padding: 0 10px">
                <div v-show="item.productRemark!==''&& item.productRemark!==null">
                  <el-popover trigger="click" placement="top">
                    <p v-html="item.productRemark " />
                    <div slot="reference" class="name-wrapper">
                      <el-tag size="medium">
                        <el-button type="text">
                          {{ $t('homePage.compile') }}
                        </el-button>
                      </el-tag>
                    </div>
                  </el-popover>
                </div>
              </td>
              <td style="text-align: left;padding: 0 10px">
                <span v-if="!item.replaceRemarks" />
                <template v-else>
                  <template v-for="items in item.replaceRemarks.split(',')">
                    <el-popover
                      :key="items"
                      style="width: auto"
                      placement="top"
                      trigger="click"
                    >
                      <span style="color: dodgerblue">{{ items }}</span>
                      <el-button
                        v-if="popoverObj.newProductCode!==null&&popoverObj.newProductCode!==''"
                        type="primary"
                        @click="added(item)"
                      >
                        <!--去替换-->
                        {{ $t('homePage.toReplace') }}
                      </el-button>
                      <div v-if="popoverObj.newProductCode==null||popoverObj.newProductCode===''">
                        <span style="color: dodgerblue">
                          <!--预上市时间：-->
                          {{ $t('addConfigModule.preListingTime') }}
                        </span>
                        <span>
                          {{ popoverObj.newShelfTime }}
                        </span>
                      </div>
                      <div>
                        <span style="color: dodgerblue">
                          <!--市场零售价格：-->
                          {{ $t('addConfigModule.marketRetailPrice') }}
                        </span>
                        <span>
                          {{ popoverObj.newRetailPrice }}
                        </span>
                      </div>
                      <div>
                        <span style="color: dodgerblue">
                          <!--产品说明：-->
                          {{ $t('addConfigModule.productDescription') }}
                        </span>
                        <span>
                          {{ popoverObj.newProductDesc }}
                        </span>
                      </div>

                      <div
                        slot="reference"
                        class="productCodeStyle"
                        style="overflow:hidden; text-overflow:ellipsis; white-space:nowrap;"
                        @click="handlePopover(items,item.productCode)"
                      >
                        <span>{{ items }}</span>
                      </div>
                    </el-popover>
                  </template>
                </template>
              </td>
            </template>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="detail-title">
      <el-row type="flex">
        <el-col :span="20" style="text-align: left">
          <div class="grid-content">
            <div class="border-l">
              <span> {{ $t('homePage.operationRecords') }}</span>
            </div>
          </div>
        </el-col>
        <el-col
          :span="4"
          style="text-align: right"
        >
          <el-button
            type="primary"
            @click="show = !show"
          >
            <span v-if="!show">
              {{ $t('homePage.anOperationRecords') }}
              <i class="el-icon-arrow-down" />
            </span>
            <span v-if="show">
              {{ $t('homePage.closingOperationRecords') }}
              <i class="el-icon-arrow-up" />
            </span>
          </el-button>
        </el-col>
      </el-row>
    </div>
    <transition name="fade">
      <div class="table-two">
        <el-table
          :data="tableData3"
          border
          v-if="show"
          :header-cell-style="{'text-align': 'left',background:'#eef1f6' }"
          style="width: 100%"
        >
          <el-table-column
            prop="addDateTime"
            :label="$t('homePage.operatingTime')"
          />
          <el-table-column
            prop="opContent"
            :label="$t('homePage.operatingContent')"
          />
        </el-table>
      </div>
    </transition>
  </div>
</template>

<script>

import api from '../../api';
import longText from '../quotationlist/longText';
import { productPriceFormat } from '@/utils/numberFormater';
import { isChannel, getStore, isPartnerM } from '@/utils/mUtils';
export default {
  name: 'OrderDetail',
  components: { longText },
  data () {
    return {
      fileArchive: null,
      projectBaseInfo: [],
      tableData6: [],
      tableData3: [],
      numArray: [],
      IsChannel: false,
      prolists: [],
      show: false,
      switchFlgP: true,
      popoverObj: {},
    };
  },
  methods: {
    handlePopover (item, productCode) {
      console.log(item);
      console.log(productCode);
      this.replaceProductModelAxios(productCode, item);
    },
    async replaceProductModelAxios (productCode, item) {
      try {
        const result = await api.replaceProductModel(productCode, item);
        console.log(result.data);
        if (result.data.status === '200') {
          this.popoverObj = result.data.data[0];
          this.popoverObj.newShelfTime = this.popoverObj.newShelfTime.substr(0, 10);
        } else {
          this.$notify.error(result.data.err);
        }
      } catch (e) {

      }
    },
    productPriceFormat,
    getStore,
    isPartnerM,
    initdata (all) {
      all.forEach((lv1, lv1index) => {
        let lv1ary = lv1.groupSubItemDListVOList;
        let gn = 0;
        lv1ary.forEach((lv2, lv2index) => {
          let lv2ary = lv2.productItems;
          lv2ary.forEach((lv3, lv3index) => {
            lv3.lv1index = lv1index;
            lv3.lv2index = lv2index;
            lv3.lv3index = lv3index;
            lv3.row2length = lv2ary.length;
            lv3.groupName = lv1.groupName;
            lv3.productSeriesName = lv2.productSeriesName;
            lv3.tcount = lv2.tcount;
            lv3.groupId = lv1.groupId;
            lv3.isServiceFlag = lv1.isServiceFlag;
            gn += lv3.purchaseQuantity * lv3.tcount;
            this.prolists.push(lv3);
          });
        });

        if (!lv1ary.length) {
          this.prolists.push({
            groupName: lv1.groupName,
            isServiceFlag: lv1.isServiceFlag,
            type: 'em'
          });
        }
        this.prolists.push({
          totalRatio: lv1.totalRatio,
          totalPrice: lv1.totalPrice,
          discountTotalPrice: lv1.discountTotalPrice,
          groupNum: gn,
          type: 'total'
        });
      });
    },
    rowspanNum1 (row) {
      let cont = 0;
      let index = row.lv1index;
      this.tableData6[index].groupSubItemDListVOList.forEach((item) => {
        let v2 = item.productItems;
        cont += v2.length;
      });
      return cont;
    },
    shareProject (projectId) {
      if (projectId != null) {
        this.$router.push({ name: '/CreatOrderFourth/fourth', query: { projectId: projectId } });
      }
    },
    exportProject (projectId) {
      if (projectId != null) {
        this.$router.push({ name: 'exportOrder/export', params: { projectId: projectId } });
      }
    },
    copyProject (projectId) {
      if (projectId != null) {
        this.$confirm(`${this.$t('homePage.copyQuotationProject')}`, `${this.$t('homePage.prompt')}`, {
          confirmButtonText: this.$t('homePage.confirm'),
          cancelButtonText: this.$t('homePage.takeAway'),
          type: 'warning'
        }).then(() => {
          api.copyProject({ params: { projectId: projectId } }).then((response) => {
            let jsonData = response.data;
            if (jsonData.status === '200') {
              this.$router.push({ name: 'QuotationList' });
            }
          });
        }).catch(() => {
          this.$notify.error(`${this.$t('homePage.copyProjectFailureError')}`);
        });
      }
    },
    editProject (projectId) {
      // 真实数据需要改name为配置组id，路由里面也需要改
      if (projectId != null) {
        this.$router.push({ name: 'CreatOrderSecond/second', query: { projectId: projectId, projectName: this.projectBaseInfo.projectName } });
      }
    },
    // 初始化项目基本信息
    initProjectBaseInfo (projectId) {
      api.getProjectBaseInfo({ params: { projectId: projectId } }).then((response) => {
        let jsonData = response.data;
        if (jsonData.status === '200') {
          this.projectBaseInfo = jsonData.data;
        }
      });
    },
    // 初始化项目包含的配置组以及产品信息
    initProduct (projectId, fileArchive) {
      api.getConfigGroupAndProductListByProjectId({ params: { projectId: projectId, fileArchive: fileArchive } }).then((response) => {
        let jsonData = response.data;
        if (jsonData.status === '200') {
          this.initdata(jsonData.data);
          this.tableData6 = jsonData.data;
        }
      });
    },
    // 初始化项目操作记录
    initProjectLog (projectId) {
      api.getProjectLogList({ params: { projectId: projectId } }).then((response) => {
        let jsonData = response.data;
        if (jsonData.status === '200') {
          this.tableData3 = jsonData.data;
        }
      }).catch((err)=>{
        console.log(err);
      });
    },
    productDesc (val) {
      let cont = '';
      cont = val.length > 25 ? val.substring(0, 25) : val;
      return cont;
    },
    changText (val) {
      if (val.ifShow === undefined) {
        this.$set(val, 'ifShow', true);
      } else {
        val.ifShow = !val.ifShow;
      }
    },
    // 获取当前用户信息
    getUserInfo () {
      let temp = getStore(`partnerFlg`);
      if (temp && temp !== '') {
        this.IsChannel = isChannel(temp);
      } else {
        api.getUserInfo().then((res) => {
          let json = res.data;
          if (json.status === '200' && json.data != null) {
            this.IsChannel = !isChannel(json.data.partnerFlg);
          } else {
            this.$notify.error(json.err);
          }
        }).catch(() => {
          this.$notify.error('网络异常');
        });
      }
    },
    added (item) {
      console.log(item);
      this.$router.push({
        name: 'AddedProduct/added',
        params: {
          groupId: item.groupId,
          projectId: item.projectId,
          isService: false
        },
        query: {
          routerPath: 'AdditionProduct'
        }
      });
    },
    toAdditionPro (groupId, groupName, isServiceFlag) {
      let params = this.$route.params;
      this.$router.push({
        name: 'AdditionProduct/add',
        params: { ...params, groupId, groupName, isService: isServiceFlag, routerPath: 'orderDetail' }
      });
    }
  },
  filters: {
    number (value) {
      return Number(value).toFixed(2);
    }
  },
  mounted () {
    let projectId = this.$route.params.projectId;
    let fileArchive = this.$route.params.fileArchive;
    this.fileArchive = fileArchive;
    this.initProjectBaseInfo(projectId);
    this.initProduct(projectId, fileArchive);
    this.initProjectLog(projectId);
  }
};
</script>

<style lang="scss">
  .order-detail {
    .group-name-styles{
      text-align: left;
      padding: 0px 10px;
      color:#36BADE;
      cursor: pointer
    }

    table tr,
    table tr th,
    table tr td,
    table tr td .el-button--text
    {
      height: 2rem;
      font-size: 1.2rem;
      padding: 0;
      margin: 0;
    }
    margin-top: 20px;
    }
  .order-detail .crumbs-navigation {
    margin-top: 0.5rem;
  }
  .order-detail .detail-title {
    margin: 30px 0px 18px;
    height: 3.2rem;
    line-height: 3.2rem;
  }

  .order-detail .detail-title .border-l {
    border-left: 4px solid #36BAE2;
    padding-left: 20px;
    height: 3.2rem;
    line-height: 3.2rem;
  }

  .order-detail .margin-t {
    margin-top: 14px;
    text-align: left;
  }

  .order-detail .margin-t:nth-of-type(3){
    margin-top: 10px;
    margin-bottom: 15px;
  }

  .order-detail .f-blue {
    font-weight: 700;
    color: #fe7500;
  }

  .order-detail .table-two {
    .cell {
      padding-left: 20px !important;
    }
  }

  .order-detail .table-one table tr td,
  .order-detail .table-one table tr th {
    border: solid 1px #EBEBEB;
  }

  .order-detail .table-one table + table,
  .order-detail .table-one table + table tr:nth-of-type(1),
  .order-detail .table-one table + table tr:nth-of-type(1) th {
    border-top: none;
  }

  .order-detail .table-one table tr {
    height: 40px;
  }

  .order-detail .table-two table tr {
    height: 40px;
  }

  .order-detail .table-one table tr td {
    color: #666666;
  }

  .order-detail #table1{
    margin: 0;
    padding: 0;
    th {
      text-align: left;
      padding: 0 20px 0 10px;
    }
  }

  .order-detail #table1 .product-dgxx table th, td {
    padding: 0;
  }

  .order-detail .table2 .product-dgxx table th, td {
    padding: 0;
  }

  .order-detail .table-one table {
    width: 100%;
    border-collapse: collapse;
    text-align: center;
  }

  .order-detail .margin-t .grid-content {
    float: left;
    margin-right: 150px;
    line-height: 3.2rem;
  }

  .order-detail .margin-t .grid-content-r {
    float: right;
    .operate-btn:hover {
      background-color: #fff !important;
    }
   .operate-btn{
     height: 32px;
     color: #3fbbdc !important;
     border: 1px solid #3fbbdc !important;
     background-color: #FFFFFF;
    }
  }

  .order-detail .table-one #table1 {
    width: 100%;
  }
  .order-detail{
    .el-tag{
      border-radius: 0;
      background-color: #FFFFFF;
      border-color: #FFFFFF;
    }
    .el-tag--medium {
      .el-button--small{
        padding: 0px 15px !important;
        margin-left: -25px;
      }
      img{
        height: 30px;
        width: 28px;
        vertical-align: middle;
      }
    }
  }
  .promotion{
    width: 32px;
    height: 20px;
    display: inline-block;
  }
  .promotion img{
    width: auto;
    height: auto;
    vertical-align: middle;
  }

  .promotion:hover img{
    width: 35px;
    vertical-align: middle;
  }

  .promotion2{
    width: 40px;
    height: 20px;
    display: inline-block;
  }
  .promotion2 img{
    width: 40px;
    height: 20px;
    vertical-align: middle;
  }
  .promotion2:hover img{
    width: 45px;
    vertical-align: middle;
  }

  @media screen and (max-width: 1366px) {
    .order-detail table tr,
    .order-detail table tr th,
    .order-detail table tr td,
    .order-detail table tr td .el-button--text {
      height: 3rem;
      font-size: 1.2rem;
      padding: 0;
      margin: 0;
    }
    .order-detail table tr,
    .order-detail table tr th,
    .order-detail table tr td {
      height: 3rem;
      font-size: 1.2rem;
    }

    .order-detail .crumbs-navigation {
      margin-top: 1.5rem;
    }

    .order-detail .detail-title {
      margin-top: 2rem;
    }

    .order-detail .table-two {
      margin-top: 2rem;
    }
  }

  .name-wrapper .el-tag:hover {
    background: none;
  }

  .cell:hover .el-tag {
    background: none;
  }

  .add-product .cell:hover .el-tag {
    border: 1px solid #36BADE;
  }

  .add-product .el-tag {
    text-overflow: ellipsis;
    display: inline-block;
    border: transparent;
    margin: 0;
    cursor: pointer;
  }

  .add-product .el-tag img{
    width: 24px;
  }
  .productCodeStyle:hover{
    color: dodgerblue;
    cursor: pointer;
  }

</style>


<style scoped lang="scss">
.table-thead th{
  padding: 0 10px !important;
  text-align: left;
  background: #eef1f6;
}
</style>

